import { BarcodePersistence } from "core/persistence";
import { BarcodeService } from "core/service";
import BaseRepository from "core/repository/base.repository";

class BarcodeRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "barcode";
  }

  resourceName() {
    return "códigos de barras";
  }

  getPersistenceProvider() {
    return BarcodePersistence;
  }

  getServiceProvider() {
    return BarcodeService;
  }

  async update(companyUuid, barcodeUuid, params) {
    return this.mService.updateBarcode(companyUuid, barcodeUuid, params);
  }

  async delete(companyUuid, barcodeUuid) {
    return this.mService.deleteBarcode(companyUuid, barcodeUuid);
  }
}

export default new BarcodeRepository();



// WEBPACK FOOTER //
// ./src/core/repository/barcode.repository.js